import { StudentRepository } from "@/domain/student-repository";
import { IAnonymousStudentService } from "@studyportals/anonymous-student-interfaces";
import { IAuthenticationServiceApplication } from "@studyportals/authentication-service-interfaces";
import { IBestfitOverviewApplication } from "@studyportals/bestfit-overview-interfaces";
import { IProfileQuestionnairesApplication } from "@studyportals/profile-questionnaires-interfaces/profile-questionnaires-application.interface.";
import { ISessionService } from "@studyportals/student-interfaces";
import { ICopilotServiceApplication } from "interfaces";


declare const STAGE: string;
declare const ROLLBAR_TOKEN: string;

const rollbarConfig = {
	accessToken: ROLLBAR_TOKEN,
	captureUncaught: false,
	captureUnhandledRejections: false,
	checkIgnore: window['rollbarIgnore'],
	payload: {
		environment: STAGE
	}
};

const application: ICopilotServiceApplication = {} as ICopilotServiceApplication;
const profileQuestionnaireApplication: IProfileQuestionnairesApplication = {} as IProfileQuestionnairesApplication;
const bestFitOverviewApplication: IBestfitOverviewApplication = {} as IBestfitOverviewApplication;
const anonymousStudentService: IAnonymousStudentService = {} as IAnonymousStudentService;
const authenticationServiceApplication: IAuthenticationServiceApplication = {} as IAuthenticationServiceApplication;
const rollbar = window && window['rollbar'] && window['rollbarIgnore'] ? new window['rollbar'](rollbarConfig) : null;
const studentRepository: StudentRepository = {} as StudentRepository;
const sessionService: ISessionService = {} as ISessionService;

export default {
	rollbar,
	application,
	profileQuestionnaireApplication,
	bestFitOverviewApplication,
	anonymousStudentService,
	authenticationServiceApplication,
	studentRepository,
	sessionService
}